import { useContext } from "react";
import NotificationsContext from "./NotificationsContext";
export var useNotificationsCtx = function () {
    var ctx = useContext(NotificationsContext);
    return ctx;
};
//# sourceMappingURL=useNotificationsCtx.js.map